import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { FiltroMeusAnunciosGoverno } from 'app/anuncio/models/filtro-meus-anuncios-governo.model';
import { AnunciosInternoPage } from '../common/anuncios-interno-page';
import { FiltroMeusAnunciosInteresse } from 'app/anuncio/models/filtro-meus-anuncios-interesse.model';
import { FiltroMeusInteresses } from 'app/anuncio/models/filtro-meus-interesses.model';
import { ChaveValor } from 'app/anuncio/models/comuns';
import { ActivatedRoute } from '@angular/router';
import { AnuncioService } from 'app/anuncio/services/anuncio.service';
import { ParametrosMeusAnunciosGoverno } from 'app/anuncio/models/parametros-meus-anuncios-governo.model';
import  * as  moment from 'moment';

/**
 * Componente de filtro, pode ser usado em qualquer página.
 * os campos aparecem de acordo com o tipo de filtro passado.
 *
 */


@Component({
  selector: 'app-filter-anuncio',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent extends AnunciosInternoPage implements OnInit, OnChanges  {


  // filtros aceitos, atualizar conforme necessário
  // FiltroMeusAnunciosGoverno | FiltroMeusAnunciosInteresse | FiltroMeusInteresses
  @Input("carregandoFiltros") carregandoFiltros!: boolean;
  @Input("filtros") filtrosProp!: FiltroMeusAnunciosGoverno | FiltroMeusAnunciosInteresse | FiltroMeusInteresses;
  //@Output() fechar = new EventEmitter<void>();
  @Output() aplicarFiltroEmmit = new EventEmitter<FiltroMeusAnunciosGoverno | FiltroMeusAnunciosInteresse | FiltroMeusInteresses>();
  @Output() exportarComFiltroEmmit = new EventEmitter<FiltroMeusAnunciosGoverno | FiltroMeusAnunciosInteresse| FiltroMeusInteresses>();

  filtros: FiltroMeusAnunciosGoverno | FiltroMeusAnunciosInteresse | FiltroMeusInteresses;
  show: boolean = false;
  parametrosExibirObject: ChaveValor[] =[];


  constructor(private route: ActivatedRoute,
    private anuncioService: AnuncioService
  ) {
    super();
  }



  //Carrega a barra de filtros no caso de um reload da tela.
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['carregandoFiltros'] && changes['carregandoFiltros'].currentValue === false) {
      this.montaExibirBarraFiltros();
      if( this.filtros instanceof FiltroMeusInteresses && (this.filtros.interessesCancelados === null || this.filtros.interessesCancelados === undefined)){
        //this.filtros.interessesCancelados = false;
      }
    }
  }

  ngOnInit() {
    this.configurarCalendario();
    //this.filtros = JSON.parse(JSON.stringify((this.filtrosProp)));
    console.debug("imprimindo filtros antes : ", this.filtrosProp);
    this.filtros = this.filtrosProp;
    this.filtros.periodoInclusao = null;
    if( this.filtros instanceof FiltroMeusAnunciosGoverno){
      this.filtros.periodoExpiracao = null;
    }
    console.debug("imprimindo filtros: ", this.filtros);

    this.popularSeparadoresTagInput();
    this.montaExibirBarraFiltros();
   // this.monitorarUrl();
  }




  public limparPeriodoInclusao(input):void {
    this.filtros.periodoInclusao = null;
    this.fecharCalendario(input);
  }

  public limparPeriodoExpiracao(input):void {
    if( this.filtros instanceof FiltroMeusAnunciosGoverno){
      this.filtros.periodoExpiracao = null;
      this.fecharCalendario(input);
    }

  }

  public limparFiltros():void {
    this.filtros.pesquisa = null;
    this.filtros.materialTiposSelecionados = [];
    this.filtros.materialCategoriasSelecionadas = [];

    this.filtros.periodoInclusao = null;

    this.filtros.anuncios = [];
    this.filtros.entidadesSelecionadas = [];

    if( this.filtros instanceof FiltroMeusInteresses){
      this.filtros.periodoAprovacao = null;
      this.filtros.ufsSelecionadas = [];
      this.filtros.anuncioInteresseSituacoesSelecionadas = [];
      this.filtros.interessesCancelados = false;
    }

    if( this.filtros instanceof FiltroMeusAnunciosGoverno){
      this.filtros.analisadoPorSelecionados = [];
      this.filtros.periodoExpiracao = null;
      this.filtros.materialSituacoesSelecionadas = [];
      this.filtros.ufsSelecionadas = [];
    }
    if( this.filtros instanceof FiltroMeusAnunciosInteresse){
      this.filtros.periodoInteresse = null;
    }
    this.aplicarFiltros();
  }

  fecharFilter() {
    this.show = !this.show;
  }

  //retorna true se o filtro possui algum valor, caso não ele não deve ser mostrado
  temFiltros(){
    return Object.keys(this.filtros).some(key => this.filtros[key] != null);
  }

  temEspecificoFiltro(key: string){
    return this.filtros[key] != null && this.filtros[key] !== undefined;
  }

  //retorna true se o filtro possui itens no array de opçoes, caso não ele não deve ser mostrado
  mostrarFiltro(key: string){
    if(this.filtros[key] !== null && this.filtros[key] !== undefined && this.filtros[key].length > 0){
      return true;
    }
    return false;
  }

  //retorna o tipo de classe para ser usado no html para mostrar os campos corretos
  tipoClasse(){
    if( this.filtros instanceof FiltroMeusAnunciosGoverno){
      return 'MEUS-ANUNCIOS-GOVERNO';
    } else if( this.filtros instanceof FiltroMeusAnunciosInteresse){
      return 'MEUS-ANUNCIOS-INTERESSE';
    } else if( this.filtros instanceof FiltroMeusInteresses){
      return 'MEUS-INTERESSES';
    } else {
      return 'MEUS-ANUNCIOS-PRIVADO';
    }
  }

  //gatilha o evento de exportar relatório
  exportar(){
    this.exportarComFiltroEmmit.emit(this.filtros);
  }

  aplicarFiltros(){
    console.debug(this.filtros);
    this.aplicarFiltroEmmit.emit(this.filtros);
    this.montaExibirBarraFiltros();
    this.fecharFilter();
  }

  abrirFilter(){
    this.show = !this.show;
  }

  // monitorarUrl() {
  //   this.route.queryParams.subscribe(
  //     params => {
  //        const parametros: ParametrosMeusAnunciosGoverno = this.anuncioService.obterParametrosMeusAnunciosGovernoUrl(params);
  //        this.montaExibirParametros(parametros);
  //     })
  // }


// popular os itens que serão mostrados na barra filtros ativos
  montaExibirBarraFiltros() {

    const parametros = this.filtros;
    this.parametrosExibirObject = [];
    if (parametros.pesquisa && parametros.pesquisa.length > 0) {
      this.parametrosExibirObject.push({chave: 'Pesquisa', valor: parametros.pesquisa, defaultChave: 'pesquisa', defaultValor: ''});
    }

    if (parametros.materialTiposSelecionados && parametros.materialTiposSelecionados.length > 0) {
      this.parametrosExibirObject.push({chave: 'Tipos', valor: parametros.materialTiposSelecionados.map(i => i.nome).join(', '), defaultChave: 'materialTiposSelecionados', defaultValor: []});
    }
    if (parametros.materialCategoriasSelecionadas && parametros.materialCategoriasSelecionadas.length > 0) {

      this.parametrosExibirObject.push({chave: 'Categorias', valor: parametros.materialCategoriasSelecionadas.map(item => item.nome).join(', ') , defaultChave: 'materialCategoriasSelecionadas', defaultValor: []});
    }
    if (parametros instanceof FiltroMeusAnunciosGoverno && parametros.materialSituacoesSelecionadas && parametros.materialSituacoesSelecionadas.length > 0) {
      this.parametrosExibirObject.push({chave: 'Situações', valor: parametros.materialSituacoesSelecionadas.map(i => i.nome).join(', '), defaultChave: 'materialSituacoesSelecionadas', defaultValor: []});
    }
    if (parametros instanceof FiltroMeusInteresses && parametros.anuncioInteresseSituacoesSelecionadas && parametros.anuncioInteresseSituacoesSelecionadas.length > 0) {
      this.parametrosExibirObject.push({chave: 'Situações do interesse', valor: parametros.anuncioInteresseSituacoesSelecionadas.map(i => i.nome).join(', '), defaultChave: 'anuncioInteresseSituacoesSelecionadas', defaultValor: []});
    }
    if (parametros instanceof (FiltroMeusAnunciosGoverno || FiltroMeusInteresses ) && parametros.ufsSelecionadas && parametros.ufsSelecionadas.length > 0) {
      this.parametrosExibirObject.push({chave: 'UFs', valor: parametros.ufsSelecionadas.map(item => item.sigla).join(', '), defaultChave: 'ufsSelecionadas', defaultValor: []});
    }
    if (parametros instanceof FiltroMeusAnunciosGoverno  && parametros.onusSelecionados && parametros.onusSelecionados.length > 0) {
      this.parametrosExibirObject.push({chave: 'Ônus', valor: parametros.onusSelecionados.map(i => i.nome).join(', '), defaultChave: 'onusSelecionados', defaultValor: []});
    }
    if (parametros instanceof (FiltroMeusAnunciosGoverno || FiltroMeusInteresses )  && parametros.periodoInclusao) {
      this.parametrosExibirObject.push({chave: 'Período de Inclusão', valor: parametros.periodoInclusao.map(i => this.dataParaString(i)).join(' a '), defaultChave: 'periodoInclusao', defaultValor: []});
    }
    if (parametros instanceof FiltroMeusInteresses && parametros.periodoAprovacao) {
      this.parametrosExibirObject.push({chave: 'Período de Aprovação', valor: parametros.periodoAprovacao.map(i => this.dataParaString(i)).join(' a '), defaultChave: 'periodoAprovacao', defaultValor: []});
    }
    if (parametros instanceof FiltroMeusAnunciosGoverno && parametros.periodoExpiracao) {
      this.parametrosExibirObject.push({chave: 'Período de Expiração', valor: parametros.periodoExpiracao.map(i => this.dataParaString(i)).join(' a '), defaultChave: 'periodoExpiracao', defaultValor: []});
    }
    if (parametros instanceof FiltroMeusAnunciosInteresse && parametros.periodoInteresse) {
      this.parametrosExibirObject.push({chave: 'Período de Interesse', valor: parametros.periodoInteresse.map(i => this.dataParaString(i)).join(' a '), defaultChave: 'periodoInteresse', defaultValor: []});
    }
    if (parametros && parametros.anuncios && parametros.anuncios.length > 0) {
      this.parametrosExibirObject.push({chave: 'Anúncios', valor: parametros.anuncios.map(i => i.value).join(', '), defaultChave: 'anuncios', defaultValor: []});
    }
    if (parametros && parametros.entidadesSelecionadas && parametros.entidadesSelecionadas.length > 0) {
      this.parametrosExibirObject.push({chave: 'Entidades', valor: parametros.entidadesSelecionadas.map(i => i.nome).join(', ') , defaultChave: 'entidadesSelecionadas', defaultValor: []});
    }
    if (parametros instanceof FiltroMeusAnunciosGoverno &&  parametros.analisadoPorSelecionados && parametros.analisadoPorSelecionados.length > 0) {
      this.parametrosExibirObject.push({chave: 'Analisado por', valor: parametros.analisadoPorSelecionados.map(i => i.nome).join(', '), defaultChave: 'analisadoPorSelecionados', defaultValor: []});
    }
    if (parametros instanceof FiltroMeusInteresses &&  parametros.interessesCancelados) {
      this.parametrosExibirObject.push({chave: 'Mostrando interesses cancelados', valor: '', defaultChave: 'interessesCancelados', defaultValor: false});
    }
  }

  removerFiltro(exbirFiltroItem: ChaveValor) {

    if (this.filtros.hasOwnProperty(exbirFiltroItem.defaultChave)) {
      this.filtros[exbirFiltroItem.defaultChave] = exbirFiltroItem.defaultValor;
      this.aplicarFiltroEmmit.emit(this.filtros);
      this.montaExibirBarraFiltros();
    }
  }

    dataParaString(data: Date) {
      return moment(data, 'DD-MM-YYYY').format('DD-MM-YYYY');
    }
}
